export const editedPermissionsCodes = [
    'HAS_WELL_LIMITATIONS',
    'HAS_ALLOWED_PERMISSION_TO_ASSIGN_LIMITATIONS',
];
